import * as React from 'react';

import { ReactFCC } from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { StyledDotsWrapper } from './styled';

export const Dots: ReactFCC = ({ children }) => {
  const isNewPdDesignEnabled = useNewPdDesignEnabled();

  return (
    <StyledDotsWrapper isNewPdDesignEnabled={isNewPdDesignEnabled}>
      {children}
    </StyledDotsWrapper>
  );
};
